import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import styled from 'styled-components/native';
import download from 'js-file-download';

import { Button } from 'app/src/elements/buttons';
import Input, { FieldLabel, StyledTextInput } from 'app/src/elements/inputs';
import { Notice, Warning, Text } from 'app/src/styles';

import { PROXIBID_EXPORT } from './queries';

export const ProxibidExport = ({ sale, setShowModal }) => {
  const [result, setResult] = useState();

  const { control, handleSubmit } = useForm({
    defaultValues: {
      includeImages: false,
      allAssets: false,
      updateAssets: false,
    }
  });

  const [proxibidExport] = useMutation(PROXIBID_EXPORT, {
    onCompleted: data => {
      const timestamp = new Date().getTime();
      setResult(data.proxibidExport);

      if (data.proxibidExport.csv) {
        download(data.proxibidExport.csv, `proxibid-${timestamp}.csv`);
      }
    }
  });

  const onSubmit = (input) => {
    proxibidExport({
      variables: {
        saleId: sale.id,
        ...input
      }
    });
  };

  return (
    <View>
      {result && !result.csv && (
        <Warning>
          <Text>No assets were found to export</Text>
        </Warning>
      )}
      <Notice>
        <Text>
          This will create a CSV file that can be uploaded to proxibid.
        </Text>
        <Text>
          By default, it only includes assets where PB has not yet been toggled
          on.
        </Text>
      </Notice>
      {/*
      <Input.Checkbox
        label="Include images in download?"
        name="includeImages"
        control={control}
      />
      */}
      <Input.Checkbox
        label="Include All Assets in Sale regardless of PB toggle?"
        name="allAssets"
        control={control}
      />
      {/*
      <Input.Checkbox
        label="Toggle PB to on for any assets included in CSV download?"
        name="updateAssets"
        control={control}
      />
      */}
      <Button
        label="Download CSV"
        onPress={handleSubmit(onSubmit)}
        wide
      />
    </View>
  );
};

export default ProxibidExport;
